import {DataTableColumn} from "mantine-datatable";
import {Product} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {NavLink} from "react-router-dom";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {Badge} from "@mantine/core";

export const useTableColumns = () => {

    const columns: DataTableColumn<Product>[] = [
        {
            accessor: 'name',
            title: I18n.get('Name'),
            width: '1fr',
            render: (item: Product) => <NavLink to={`/products/${item.id}`}>{item.name}</NavLink>,
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            width: '120px',
            render: (item: Product) => (
                <Badge
                    color={item.status === 'Active' ? 'green' : item.status === 'Draft' ? 'yellow' : 'red'}
                    variant="light"
                >
                    {item.status || 'UNKNOWN'}
                </Badge>
            ),
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: Product) => formatTimestamp(item.created),
        },

    ];

    return {
        columns,
    }
}